import TeacherResultEntry from './TeacherResultEntry';
import TeacherResultAssessmentTabs from './TeacherResultAssessmentTabs';

const TeacherEnterTest = () => (
  <TeacherResultAssessmentTabs>
    <TeacherResultEntry assessmentType="first_test" />
  </TeacherResultAssessmentTabs>
);

export default TeacherEnterTest;
